export const PopupTypes = {
  gameReady: 'gameReady',
  GameRules: 'GameRules',
  Fairness: 'Fairness',
  HotKeys: 'HotKeys',
  SlowConnection: 'SlowConnection',
  Reconnect: 'Reconnect',
  ConnectionError: 'ConnectionError',
  TournamentFinished: 'tournamentFinished',
  onOpenerIconClick: 'onOpenerIconClick',
};
